import styled, { css } from 'styled-components';

export const DateLabelWrapper = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  ${props => props.margin && css`
    margin: ${props.margin}
  `};
`;



// WEBPACK FOOTER //
// ./src/components/shared/DateLabel/styles.js